import jwtDecode from 'jwt-decode';

export default (role) => {
    const token = sessionStorage.getItem('auth-token');
    const data = jwtDecode(token);

    if (role === data.rights) {
        return true;
    }
    switch (role) {
        case 'repair':
            if (data.rights === 'repair' || data.rights === 'power_user' || data.rights === 'admin')
                return true;
            return false;
        case 'power_user':
            if (data.rights === 'power_user' || data.rights === 'admin')
                return true;
            return false;
        case 'admin':
            if (data.rights === 'admin')
                return true;
            return false;
        default:
            return false;
    }
};